import {FC} from 'react';
import { useForm } from 'react-hook-form';
import CertificateUploadCard from '../../../components/file/CertificateUploadCard';
import { IPersonalInfo } from '../../../common/state/subscriptions/personal_info';
import { IPaymentInfo } from '../../../common/state/subscriptions/payment_info';
import { IGeneralInfo } from '../../../common/state/subscriptions/general_info';
// custom

export type SubscriptionEmailFormData = {
    name: string,
    email: string,
    status: string,
    certificate: string
};

type ISubscriptionEmailFormProps = {    
    defaultFormData: SubscriptionEmailFormData,
    onSubmit: (data: SubscriptionEmailFormData) => void
};


const SubscriptionEmailForm: FC<ISubscriptionEmailFormProps> = ({defaultFormData, onSubmit}) => {
    const { register, handleSubmit, setValue } = useForm<SubscriptionEmailFormData>({defaultValues: defaultFormData});

    // evt handlers    
    const onFormSubmit = (formData: SubscriptionEmailFormData) => {
        // validation
        const isNotEmpty =  Object.values(formData).every(value => value !== undefined && value !== '');        
        if (!isNotEmpty) {
            return console.log('Error, empty fields!', formData);
        }
        // console.log('Form data is: ', formData);
        onSubmit(formData);
        
    };

    return <section
    className="flex flex-row flex-wrap w-full lg:flex-nowrap justify-space-between">
    <section
        id="form-section"
        className="p-4 my-3 mr-3 bg-white shadow-lg grow rounded-xl dark:bg-gray-900">
        <form 
            onSubmit={handleSubmit(onFormSubmit)}
            className="flex flex-wrap w-full mb-6">
            <h2 className='my-4 text-2xl text-gray-700 dark:text-teal-300'>Registration Letter</h2>    
            {/* First Row */}
            <div className="w-full px-3 mb-6 md:mb-0">
                <label
                    className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-name">
                    Attendee Name*
                </label>
                <input
                    {...register('name')}
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-name"
                    type="text"
                    placeholder="Mr. John Doe"/>
                <p className="hidden text-xs italic text-red-500">Required</p>
            </div>
            {/* Second Row */}
            <div className="w-full px-3">
                <label
                    className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-email">
                    Recipient Email*
                </label>
                <input
                    {...register('email')}
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-email"
                    type="text"
                    placeholder="john.doe@gmail.com"/>
                <p className="hidden text-xs italic text-red-500">Required</p>
            </div>
            {/* Third Row */}
            <div className="w-full px-3 mb-6 md:mb-0">
                <label
                    className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-status">
                    Status*
                </label>
                <select
                    {...register('status')}
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-status">
                        <option value="initiated">Initiated</option>
                        <option value="success">Success</option>
                    </select>
                    
                    

                <p className="hidden text-xs italic text-red-500">Required</p>
            </div>
            {/* Fourth Row */}
            <div className="w-full px-3 mb-6 md:mb-0">
                <label
                    className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-first-name">
                    Certificate URL*
                </label>
                <input
                    {...register('certificate')}
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-first-name"
                    type="text"                                
                    placeholder="https://www.powerministry.info/certificates/attendee.pdf"/>

                <p className="hidden text-xs italic text-red-500">Required</p>
            </div>                        
            {/* Submit button */}
            <button                
                type='submit'                            
                className="px-4 py-2 mx-3 my-6 font-bold text-white bg-blue-500 border-b-4 border-blue-700 rounded hover:bg-blue-400 disabled:bg-blue-200 disabled:cursor-not-allowed hover:border-blue-500 disabled:border-blue-200">
                Send Email
            </button>
            <button
                type='reset'
                className="px-4 py-2 mx-3 my-6 font-bold text-gray-700 bg-gray-300 border-b-4 border-gray-500 rounded hover:bg-gray-400 hover:text-white hover:border-gray-700">
                Cancel
            </button>
        </form>
            {/* <p className={`${getValues('general.status') === 'success' ? 'hidden': 'visible'} text-sm italic font-bold text-red-500`}>*You can only send emails if the payment is of status: success</p> */}
    </section>
    <CertificateUploadCard onSelect={(url : string) => setValue('certificate', url)}/>
</section>
};

export default SubscriptionEmailForm;